import axios from 'axios';
import { BACKEND_URL } from '../config';

// 🛡️ LOGIN GATEWAY RETRY (Oct 2026): ride out transient Cloudflare 502/520-524 origin blips.
const TRANSIENT = new Set([502, 503, 504, 520, 521, 522, 523, 524, 525, 526, 530]);
const BACKOFF_MS = [1500, 3000, 6000, 10000];

const isTransient = (err) => {
  if (!err.response) return true;
  if (TRANSIENT.has(err.response.status)) return true;
  const detail = String(err.response.data?.detail || err.response.data || '');
  return /cloudflare|origin web server/i.test(detail);
};

export const postLogin = async (payload, onRetry) => {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await axios.post(`${BACKEND_URL}/api/login`, payload, { timeout: 30000 });
    } catch (err) {
      if (attempt >= BACKOFF_MS.length || !isTransient(err)) throw err;
      if (onRetry) onRetry(attempt + 1);
      await new Promise((r) => setTimeout(r, BACKOFF_MS[attempt]));
    }
  }
};

export const friendlyLoginError = (err, fallback) => {
  if (isTransient(err)) {
    return 'The server is busy right now and could not complete your login. Please wait a moment and try again.';
  }
  return err.response?.data?.detail || err.response?.data?.message || fallback;
};
